export default {
  name: 'cartItem',
  component() {
    return (itemKey) => ({
      itemKey,
      
      get item() { return this.$store.cart.getItemByKey(this.itemKey); },
      get quantity() { return this.item?.quantity || 0; },
      get linePrice() { return this.$store.cart.formatPrice(this.item?.final_line_price || 0); },
      
      async updateQuantity(qty) {
        try {
          await this.$store.cart.updateQuantity(this.itemKey, qty);
        } catch (error) {
          console.error('Failed to update quantity:', error);
        }
      },
      
      async remove() {
        try {
          await this.$store.cart.remove(this.itemKey);
        } catch (error) {
          console.error('Failed to remove item:', error);
        }
      }
    });
  }
};